import React from "react";
import { useMessageSource } from "react-message-source";
import FailureImage from "../../../resources/images/swisscom-dis-failure-icon.svg";
import ContentFooter from "../../../ui/layout/page/content/footer";
import NavigationBar from "../../../ui/layout/page/content/footer/navigation-bar";
import { Grid } from "@mui/material";
import Image from "../../../ui/widgets/image";
import CustomTypography from "../../../ui/widgets/typography";
import PageContent from "../../../ui/layout/page/content";

export default function DisSkipSign({
  next,
  loggedIn,
}: {
  next: () => void;
  loggedIn: boolean;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();
  const messageSuffix = loggedIn ? "-logged-in" : "-not-logged-in";

  return (
    <>
      <PageContent>
        <Grid container spacing={4} alignItems="center">
          <Grid>
            <Image src={FailureImage} />
          </Grid>
          <Grid>
            <CustomTypography variant="h3">
              {getMessage(`SwisscomDis.skipSign-title${messageSuffix}`)}
            </CustomTypography>
            <CustomTypography variant="body1">
              {getMessage(`SwisscomDis.skipSign-info${messageSuffix}`)}
            </CustomTypography>
          </Grid>
        </Grid>
        <ContentFooter>
          <NavigationBar
            onNext={next}
            nextButtonText={getMessage("Onboarding.continue")}
          />
        </ContentFooter>
      </PageContent>
    </>
  );
}
